import React from 'react';

export default function ImagesPage() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">Images</h1>
      <p>Images page not implemented yet.</p>
    </div>
  );
}